// test344
(344 && 0);
